
import { state } from "@/store/modules/tournament/state";
import mutations from "@/store/modules/tournament/mutations"
import actions from "@/store/modules/tournament/actions"
import getters from "@/store/modules/tournament/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}